import styled, { css } from "styled-components";

const commonTextStyles = css`
	color: #fff;
	text-align: center;
`;

const commonButtonStyles = css`
	display: flex;
	justify-content: center;
	align-items: center;
	color: var(--Gray-00, #fff);
	text-align: center;
	cursor: pointer;
`;

export const NoContentWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	height: 100%;
	width: 100%;
	min-height: 400px;
	padding: 0px 20px;

	@media (min-width: 430px) {
		padding: 0px 40px;
	}

	@media (min-width: 744px) {
		padding: 0px;
	}
`;

export const NoContentImage = styled.div`
	margin-bottom: 10px;
`;

export const NoContentText = styled.div`
	${commonTextStyles}
	font-size: 24px;
	font-weight: 700;
	line-height: 36px;
	letter-spacing: 1px;
	margin-bottom: 15px;

	@media (min-width: 1024px) {
		line-height: 32px;
		font-size: 28px;
	}
`;

export const NoContentSubText = styled.div`
	${commonTextStyles}
	font-size: 14px;
	line-height: 20px;
	letter-spacing: 0.75px;
	margin-bottom: 100px;
`;

export const ShowAllGamesButton = styled.div`
	${commonButtonStyles}
	height: 40px;
	padding: 0 20px;
	font-size: 14px;
	font-weight: 600;
	line-height: 20px;
	letter-spacing: 0.75px;
	border-radius: 20px;
	background: var(--main-gradient);
`;
